import React, { memo } from "react"
import { Center } from "@chakra-ui/react"
import Icon from "@app/components/Icon"

type Props = {
  numOfStars: number
  size?: number
}

export const ReviewStarRating: React.FC<Props> = memo(({ numOfStars, size = 5 }) => {
  const flatReview = Math.floor(numOfStars || 0)
  const decimal = Math.abs((numOfStars || 0) - flatReview)

  const stars = Array.from({ length: 5 }, (_, index) => {
    if (flatReview === index) {
      if (decimal < 0.5) {
        return <Icon key={index} name={decimal >= 0.25 ? "reviewStarHalf" : "reviewStarEmpty"} width={size} height={size} />
      }
      return <Icon key={index} name={decimal >= 0.75 ? "reviewStarFull" : "reviewStarHalf"} width={size} height={size} />
    }
    return <Icon key={index} name={flatReview >= index ? "reviewStarFull" : "reviewStarEmpty"} width={size} height={size} />
  })

  // row height matches the star size (16px at size 4) instead of inheriting a 20px line-height
  return (
    <Center gap={1} h={size} lineHeight={1}>
      {stars}
    </Center>
  )
})
